module.exports = __webpack_public_path__ + "static/media/user_cadastro.2ed3b113.svg";